export default "__VITE_ASSET__AWqs0MKh__"